import { actionTypes, fetchApi, ValidateLoyaltyCodeDeferred } from "./Actions";

const validateLoyaltyCode: ValidateLoyaltyCodeDeferred = (
  lp: string,
  code: string,
  ai: string
) => {
  const queryUrl: string =
    'lookup/vLC.htm?lp=' +
    lp.toUpperCase() +
    '&i=' +
    code +
    '&ai=' +
    (ai !== undefined ? ai : '');
  return fetchApi(`/bestilling/${queryUrl}`, actionTypes.VALIDATE_LOYALTY_CODE);
};

export default validateLoyaltyCode;
